var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"hidden","value":"格米尼网络科技有限公司开发"}}),_c('GlobalFooter',{staticClass:"i-copyright",attrs:{"links":_vm.links,"copyright":_vm.copyright}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }